// Static mock data for Appy Hour

export const CATEGORIES = [
  { id: "general", name: "General Knowledge", icon: "Brain", color: "amber" },
  { id: "sports", name: "Sports", icon: "Trophy", color: "green" },
  { id: "music", name: "Music", icon: "Music", color: "pink" },
  { id: "movies", name: "Movies & TV", icon: "Clapperboard", color: "purple" },
  { id: "science", name: "Science", icon: "FlaskConical", color: "cyan" },
  { id: "history", name: "History", icon: "Landmark", color: "amber" },
  { id: "local", name: "Local Trivia", icon: "MapPin", color: "pink" },
  { id: "lore", name: "Regional Lore", icon: "Ghost", color: "purple" },
];

export const DIFFICULTIES = [
  { id: "easy", name: "Easy", desc: "Warm-up pints" },
  { id: "medium", name: "Medium", desc: "Proper pub level" },
  { id: "hard", name: "Hard", desc: "Quiz legend" },
];

export const TIMER_OPTIONS = [10, 15, 20];

export const VENUES = [
  { id: "v1", name: "The Tipsy Otter", type: "Traditional Pub", distance: 3, rating: 4.7, live: 12, tag: "Live Now" },
  { id: "v2", name: "Neon Alley Bar", type: "Cocktail Bar", distance: 6, rating: 4.5, live: 8, tag: "Tonight 8pm" },
  { id: "v3", name: "The Crown & Compass", type: "Gastropub", distance: 9, rating: 4.8, live: 21, tag: "Live Now" },
  { id: "v4", name: "Foxhole Taproom", type: "Craft Beer", distance: 14, rating: 4.3, live: 5, tag: "Weekly Fri" },
  { id: "v5", name: "The Rusty Anchor", type: "Sports Bar", distance: 22, rating: 4.1, live: 0, tag: "Sat 7pm" },
  { id: "v6", name: "Moonlight Social Club", type: "Late Lounge", distance: 35, rating: 4.6, live: 3, tag: "Live Now" },
];

export const GROUPS = [
  { id: "g1", name: "Quiz Goblins", members: 24, distance: 4, emoji: "🧟", vibe: "Chaotic & competitive" },
  { id: "g2", name: "The Know-It-Ales", members: 16, distance: 8, emoji: "🍺", vibe: "Casual Friday crew" },
  { id: "g3", name: "Trivia Titans", members: 38, distance: 18, emoji: "⚡", vibe: "Serious point hunters" },
  { id: "g4", name: "Pub Philosophers", members: 11, distance: 30, emoji: "🦉", vibe: "Deep thoughts, light beer" },
];

export const BOTS = [
  { name: "QuizWizKaz", avatar: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxoYXBweSUyMHNtaWxpbmclMjBwZXJzb24lMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUzNjk1Njd8MA&ixlib=rb-4.1.0&q=85" },
  { name: "BrainyBev", avatar: "https://images.unsplash.com/photo-1583264277168-58ceba4b84e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxoYXBweSUyMHNtaWxpbmclMjBwZXJzb24lMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUzNjk1Njd8MA&ixlib=rb-4.1.0&q=85" },
  { name: "PintSizedPro", avatar: null },
  { name: "LagerLuke", avatar: null },
  { name: "TriviaTina", avatar: null },
];

export const QR_TILES = [
  { id: "qr1", label: "Table 4", venue: "The Tipsy Otter", category: "general", color: "amber" },
  { id: "qr2", label: "Booth 2", venue: "Neon Alley Bar", category: "music", color: "pink" },
  { id: "qr3", label: "Bar Top", venue: "Crown & Compass", category: "movies", color: "purple" },
  { id: "qr4", label: "Snug", venue: "Foxhole Taproom", category: "sports", color: "cyan" },
  { id: "qr5", label: "Patio", venue: "The Rusty Anchor", category: "local", color: "green" },
  { id: "qr6", label: "Loft", venue: "Moonlight Social", category: "lore", color: "amber" },
];

export const FALLBACK_QUESTIONS = [
  { question: "Which planet is known as the Red Planet?", options: ["Venus", "Mars", "Jupiter", "Saturn"], answer_index: 1 },
  { question: "How many strings does a standard guitar have?", options: ["4", "5", "6", "7"], answer_index: 2 },
  { question: "What is the capital city of Australia?", options: ["Sydney", "Melbourne", "Canberra", "Perth"], answer_index: 2 },
  { question: "In which sport would you perform a 'slam dunk'?", options: ["Tennis", "Basketball", "Cricket", "Golf"], answer_index: 1 },
  { question: "Who painted the Mona Lisa?", options: ["Van Gogh", "Picasso", "Da Vinci", "Monet"], answer_index: 2 },
];
